module.exports = __webpack_public_path__ + "81411c732abf69862baaaf544192e20a.svg";